import Main from "@/views/Main.vue";
import MainHue from "@/views/customized-queries/customized-queries.vue";

// 不作为Main组件的子页面展示的页面单独写，如下
export const loginRouter = {
  path: "/view/login",
  name: "login",
  meta: {
    title: "Login - 登录"
  },
  component: () => import("@/views/login.vue")
};
export const HueRouters = {
  path: "/view/customized-queries",
  name: "queries",
  meta: {
    title: "自定义查询"
  },
  component: () => import("@/views/customized-queries/customized-queries.vue")
};

export const page404 = {
  path: "/view/*",
  name: "error-404",
  meta: {
    title: "404-页面不存在"
  },
  component: () => import("@/views/error-page/404.vue")
};

export const page403 = {
  path: "/view/403",
  meta: {
    title: "403-权限不足"
  },
  name: "error-403",
  component: () => import("@//views/error-page/403.vue")
};

export const page500 = {
  path: "/view/500",
  meta: {
    title: "500-服务端错误"
  },
  name: "error-500",
  component: () => import("@/views/error-page/500.vue")
};

// 概览邮件截图页面
export const dashboardForMail = {
  path: "/view/dashboard/:projectId/:dashboardId",
  meta: {
    title: "邮件数据概览"
  },
  name: "dashboards",
  component: () => import("@/views/dashboards/dashboards.vue")
};

// Main
const mainRouters = {
  path: "/",
  name: "otherRouter",
  redirect: "/view/home",
  component: Main,
  children: [
    {
      path: "/view/home",
      title: "home",
      name: "home",
      component: () => import("@/views/home/home.vue")
    }
  ]
};

export const channelLink = {
  path: "/view/channel/link",
  meta: {
    title: "唤醒链接"
  },
  name: "channel-link",
  component: () => import("@/views/channel/link.vue")
};

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
  path: "/",
  name: "otherRouter",
  redirect: "/view/home",
  component: Main,
  children: [
    // {path: 'home', title: 'home', name: 'home', component: () => import('@/views/home/home.vue')},
    {
      path: "/view/action-sequence",
      meta: {
        title: "用户行为序列"
      },
      name: "action-sequence",
      component: () => import("@/views/sequence/action-sequence.vue")
    },
    {
      path: "/view/user-detail-table/:type",
      meta: {
        title: "用户列表"
      },
      name: "user-detail-table",
      component: () => import("@/views/user-detail-table/user-detail-table.vue")
    },
    {
      path: "/view/segmentation-result/:segmentationId",
      // path: "/view/segmentation-result/:segmentationId",
      meta: {
        title: "用户分群结果"
      },
      name: "segmentation-result",
      component: () => import("@/views/segmentation/segmentation-result.vue")
    },
    {
      path: "/view/operation-result",
      // path: "/view/segmentation-result/:segmentationId",
      meta: {
        title: "运营计划分组结果"
      },
      name: "operation-result",
      component: () => import("@/views/operation-plan/operation-result.vue")
    },
    {
      path: "/view/bookmark-list",
      meta: {
        title: "书签列表"
      },
      name: "bookmark-list",
      component: () => import("@/views/bookmark/bookmark-list.vue")
    },
    {
      path: "/view/user-info-list",
      meta: {
        title: "用户明细列表"
      },
      name: "user-info-list",
      component: () => import("@/views/user-info-list/user-info-list.vue")
    },
    {
      path: "/view/operation-set",
      meta: {
        title: "全局触达限制"
      },
      name: "operation-set",
      component: () => import("@/views/operation-config/operation-set.vue")
    },
    {
      path: "/view/opera-map",
      meta: {
        title: "触达通道管理"
      },
      name: "opera-map",
      component: () => import("@/views/operation-config/opera-map.vue")
    },
    {
      path: "/view/flow-create",
      meta: {
        title: "创建流程"
      },
      name: "flow-create",
      component: () => import("@/views/operation-flow/flow-create.vue")
    },
    {
      path: "/view/buried-point-analysis-details",
      meta: {
        title: "埋点详情"
      },
      name: "buried-point-analysis-details",
      component: () => import("@/views/buried-point-analysis-details/buried-point-analysis-details.vue")
    },
    {
      path: "/view/road-set",
      meta: {
        title: "渠道归因设置"
      },
      name: "roadSet",
      component: () => import("@/views/ad-channel-management/road-set.vue")
    },
    {
      path: "/view/space-list",
      meta: {
        title: "设备白名单"
      },
      name: "spaceList",
      component: () => import("@/views/ad-channel-management/space-list.vue")
    },
    {
      path: "/view/ltv-report-table",
      meta: {
        title: "LTV分析模型"
      },
      name: "ltvReportTable",
      component: () => import("@/views/ad-report-conf/ad-ltv-report.vue")
    },
    {
      path: "/view/relen-report-table",
      meta: {
        title: "留存分析模型"
      },
      name: "relenReportTable",
      component: () => import("@/views/ad-report-conf/relen-report-table.vue")
    },
    {
      path: "/view/custom-report",
      meta: {
        title: "自定义指标"
      },
      name: "customReport",
      component: () => import("@/views/ad-report-conf/custom-report.vue")
    },
    {
      path: "/view/android-report-ref",
      meta: {
        title: "安卓商店标记关联"
      },
      name: "androidReportRef",
      component: () => import("@/views/ad-report-conf/android-report-ref.vue")
    },
    {
      path: "/view/channel-set",
      meta: {
        title: "回传配置"
      },
      name: "channelSet",
      component: () => import("@/views/ad-channel-management/channel-set.vue")
    },
    {
      path: "/view/channel-key-set",
      meta: {
        title: "密钥配置"
      },
      name: "channelKeySet",
      component: () => import("@/views/ad-channel-management/channel-key-set.vue")
    },
    {
      path: "/view/flow-edit",
      meta: {
        title: "编辑流程"
      },
      name: "flow-edit",
      component: () => import("@/views/operation-flow/flow-edit.vue")
    },
    {
      path: "/view/flow-mix",
      meta: {
        title: "流程画布详情"
      },
      name: "flow-mix",
      component: () => import("@/views/operation-flow/flow-mix.vue")
    },
    {
      path: "/view/data-source-warehouse/Hive",
      meta: {
        title: '数据源管理 数据接入'
      },
      name: 'Hive',
      component: () => import("@/views/data-source-warehouse/Hive.vue")
    },
    {
      path: "/view/data-source-warehouse/mysql",
      meta: {
        title: '数据源管理 数据接入'
      },
      name: 'mysql',
      component: () => import("@/views/data-source-warehouse/mysql.vue")
    },
    {
      path: "/view/data-source-warehouse/Oracle",
      meta: {
        title: '数据源管理 数据接入'
      },
      name: 'Oracle',
      component: () => import("@/views/data-source-warehouse/Oracle.vue")
    },
    {
      path: "/view/data-source-warehouse/FTP",
      meta: {
        title: '数据源管理 数据接入'
      },
      name: 'FTP',
      component: () => import("@/views/data-source-warehouse/FTP.vue")
    },
    {
      path: "/view/data-source-warehouse/OfficialAccount",
      meta: {
        title: '数据源管理 数据接入'
      },
      name: 'OfficialAccount',
      component: () => import("@/views/data-source-warehouse/OfficialAccount.vue")
    },
    {
      path: "/view/data-source-warehouse/MiniApps",
      meta: {
        title: '数据源管理 数据接入'
      },
      name: 'MiniApps',
      component: () => import("@/views/data-source-warehouse/MiniApps.vue")
    },
    {
      path: "/view/data-source-warehouse/WeCom",
      meta: {
        title: '数据源管理 数据接入'
      },
      name: 'WeCom',
      component: () => import("@/views/data-source-warehouse/WeCom.vue")
    },
    {
      path: "/view/data-source-warehouse/BaiduSeo",
      meta: {
        title: '数据源管理 数据接入'
      },
      name: 'BaiduSeo',
      component: () => import("@/views/data-source-warehouse/BaiduSeo.vue")
    },
    {
      path: "/view/data-source-warehouse/BaiduSem",
      meta: {
        title: '数据源管理 数据接入'
      },
      name: 'BaiduSem',
      component: () => import("@/views/data-source-warehouse/BaiduSem.vue")
    },
    {
      path: "/view/buried-point-analysis-details",
      meta: {
        title: "埋点详情"
      },
      name: "buried-point-analysis-details",
      component: () => import("@/views/buried-point-analysis-details/buried-point-analysis-details.vue")
    },
    {
      path: "/view/ad-grant-manage-detail",
      meta: {
        title: "授权详情"
      },
      name: "ad-grant-manage-detail",
      component: () => import("@/views/ad-grant-manage/ad-grant-manage-detail.vue")
    },
  ]
};
export const appRouter = {
  path: "/",
  name: "appRouter",
  component: Main,
  children: []
};

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
  mainRouters,
  loginRouter,
  HueRouters,
  page500,
  page403,
  {
    path: "/view/dashboard/:project/:id",
    name: "dashboard-end",
    meta: {
      title: '服务器数据概览'
    },
    component: () => import("@/views/dashboards/dashboard-end.vue")
  },
  dashboardForMail,
  channelLink
];



// WEBPACK FOOTER //
// ./src/router/router.js